import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/images/logo.png";
import Navbar from "../components/layout/Navbar";
import "../assets/styles/home.css";

function Home() {
  const [showRegister, setShowRegister] = useState(false);
  const [open, setOpen] = useState(false);

  const handleJoinClick = () => {
    setShowRegister(true);
  };

  return (
    <div className="home">
      {/* ===== NAVBAR ===== */}
      <nav className="home-navbar">
        <div className="nav-logo">Shuttle Craft Badminton Academy</div>
        <div className="menu-toggle" onClick={() => setOpen(!open)}>
          ☰
        </div>

        <div className={`nav-links ${open ? "active" : ""}`}>
          <Link to="/student-login" className="student-link">
            {" "}
            Sign In
          </Link>
          <a href="#about">About</a>
          <a href="#contact">Contact</a>
          <Link to="/register">Sign Up</Link>

          <a href="#programs">Programs</a>

          <Link to="/admin-login" className="admin-link">
            Admin
          </Link>
        </div>
      </nav>

      {/* ===== HERO ===== */}
      <section className="hero">
        <div className="hero-left">
          <h1>Shuttle Craft Badminton Academy</h1>
          <p>
            Professional Badminton Coaching With Structured Training, Tournament
            Preparation And Expert Guidance.
          </p>

          <Link to="/register">
            <button className="btn-primary">Join Now</button>
          </Link>
        </div>

        <div className="hero-right">
          <img src={logo} alt="Shuttle Craft Logo" className="hero-logo" />
        </div>
      </section>

      {/* ===== ELITE ABOUT SECTION ===== */}
      <section id="about" className="about-elite">
        <div className="about-header">
          <h2>Meet The Head Coach</h2>
          <h3>Prajwal Rao MB</h3>
          <p className="elite-badge">
            🏅 Merit Holder – Second Position (2025)
          </p>
        </div>

        <div className="about-content">
          <div className="about-description">
            <p>
              Certified Badminton Coach And Distinguished South Zone University
              Representative Achieved a Hat-Trick Selection Representing
              Bengaluru North University in Three Consecutive All India
              Inter-University Championships.
            </p>
          </div>

          <div className="achievement-cards">
            <div className="ach-card">
              <h4>VIT University</h4>
              <p>Vellore – 2023</p>
            </div>

            <div className="ach-card">
              <h4>SRM University</h4>
              <p>Chennai – 2024</p>
            </div>

            <div className="ach-card">
              <h4>KL University</h4>
              <p>Vijayawada – 2026</p>
            </div>

            <div className="ach-card gold">
              <h4>Open State Tournament</h4>
              <p>Multiple Wins | Clean Sweep Doubles</p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== PROGRAMS ===== */}
      <section id="programs" className="programs">
        <h2>Our Coaching Programs</h2>

        <div className="program-grid">
          <div className="program-card blue">
            <h4>Beginner Training</h4>
            <p>Basic Skills, Footwork And Game Fundamentals.</p>
          </div>

          <div className="program-card green">
            <h4>Intermediate Training</h4>
            <p>Advanced Drills, Strategy And Match Simulation.</p>
          </div>

          <div className="program-card orange">
            <h4>Professional Training</h4>
            <p>Tournament Preparation And Performance Coaching.</p>
          </div>
        </div>
      </section>

      {/* ===== REGISTER ===== */}
      {showRegister && (
        <section id="register" className="register">
          <h2>Student Registration</h2>

          <form>
            <input type="text" placeholder="Student Name" required />
            <input type="text" placeholder="Phone Number" required />
            <input type="text" placeholder="Preferred Batch" required />

            <button type="submit" className="btn-primary">
              Register Now
            </button>
          </form>
        </section>
      )}

      {/* ===== CONTACT ===== */}
      <section id="contact" className="contact">
        <h2>Contact</h2>
        <p>Phone: 6362310247</p>
        <p>Bangalore, Karnataka</p>

        <div className="social-buttons">
          <a
            href="https://wa.me/916362310247"
            target="_blank"
            rel="noreferrer"
            className="social whatsapp"
          >
            WhatsApp
          </a>

          <a
            href="https://instagram.com/shuttlecraftbadmintonacademy"
            target="_blank"
            rel="noreferrer"
            className="social instagram"
          >
            Instagram
          </a>

          <a href="mailto:shuttlecraftb@gmail.com" className="social gmail">
            Gmail
          </a>
        </div>
      </section>

      {/* ===== FOOTER ===== */}
      <footer>© 2026 Shuttle Craft Badminton Academy</footer>
    </div>
  );
}

export default Home;
